import { DataLayer } from './DataLayer';
import { ErrorType } from './types';

const dataLayer = new DataLayer();

export const trackOnAuthenticationPage = () => {
  const dl = dataLayer.clone();
  dl.set('pageName', 'Landing page')
    .set('viewChange', 'Landing page')
    .set('eventInfo[0]', 'Journey', 'Start');
  dl.write('page');
};

export const trackOnAuthenticationPageInputError = () => {
  const dl = dataLayer.clone();
  dl.set('pageName', 'Landing page').set('viewChange', 'Input error');
  dl.write('interaction');
};
export const trackOnAuthenticationPageAlreadyPaid = () => {
  const dl = dataLayer.clone();
  dl.set('pageName', 'Landing page').set('viewChange', 'Already paid');
  dl.write('interaction');
};

export const trackOnSecondAuthPage = () => {
  const dl = dataLayer.clone();
  dl.set('pageName', 'TAN input').set('viewChange', 'TAN input');
  dl.write('page');
};
export const trackOnSecondAuthPageInputError = () => {
  const dl = dataLayer.clone();
  dl.set('pageName', 'TAN input').set('viewChange', 'Input error');
  dl.write('interaction');
};

export const trackOnOverviewPage = () => {
  const dl = dataLayer.clone();
  dl.set('pageName', 'Overview').set('viewChange', 'Overview');
  dl.write('page');
};

export const trackOnPaymentPage = () => {
  const dl = dataLayer.clone();
  dl.set('pageName', 'Payment').set('viewChange', 'Payment');
  dl.write('page');
};

export const trackOnPaymentSuccess = () => {
  const dl = dataLayer.clone();
  dl.set('pageName', 'Summary')
    .set('viewChange', 'Payment successful')
    .set('eventInfo[0]', 'Journey', 'End')
    .set('eventInfo[1]', 'Payment', 'Success');
  dl.write('page');
};
export const trackOnSummaryFailed = () => {
  const dl = dataLayer.clone();
  dl.set('pageName', 'Summary')
    .set('viewChange', 'Payment failed')
    .set('eventInfo[0]', 'Journey', 'End')
    .set('eventInfo[1]', 'Payment', 'Failed');
  dl.write('page');
};

export const trackOnStandardError = (type: ErrorType) => {
  const dl = dataLayer.clone();
  switch (type) {
    case 'Unauthorized':
      dl.set('pageName', 'Error: Unauthorized (401)')
        .set('viewChange', 'Error: Unauthorized (401)')
        .set('eventInfo[0]', 'Error', 'Login: Unauthorized');
      break;

    case 'Not Found':
      dl.set('pageName', 'Error: Page not found (404)')
        .set('viewChange', 'Error: Page not found (404)')
        .set('eventInfo[0]', 'Error', 'Page not found');
      break;
    case 'Internal Server Error':
      dl.set('pageName', 'Error: Internal server error (500)')
        .set('viewChange', 'Error: Internal server error (500)')
        .set('eventInfo[0]', 'Error', 'Technical error');
      break;
    default:
      break;
  }
  dl.write('page');
};

// --- Adyen Payment Tracking ---

export const trackOnAdyenSessionCreated = () => {
  const dl = dataLayer.clone();
  dl.set('pageName', 'Payment')
    .set('viewChange', 'Adyen: Session created')
    .set('eventInfo[0]', 'Payment', 'Session Created');
  dl.write('interaction');
};

export const trackOnAdyenSessionFailed = (statusCode: number) => {
  const dl = dataLayer.clone();
  dl.set('pageName', 'Payment')
    .set('viewChange', `Adyen: Session creation failed (${statusCode})`)
    .set('eventInfo[0]', 'Payment', 'Session Creation Failed');
  dl.write('interaction');
};

export const trackOnAdyenWidgetLoaded = () => {
  const dl = dataLayer.clone();
  dl.set('pageName', 'Payment')
    .set('viewChange', 'Adyen: Drop-in widget loaded')
    .set('eventInfo[0]', 'Payment', 'Widget Loaded');
  dl.write('interaction');
};

export const trackOnAdyenWidgetError = () => {
  const dl = dataLayer.clone();
  dl.set('pageName', 'Payment')
    .set('viewChange', 'Adyen: Drop-in widget error')
    .set('eventInfo[0]', 'Payment', 'Widget Error');
  dl.write('interaction');
};

export const trackOnAdyenPaymentCompleted = () => {
  const dl = dataLayer.clone();
  dl.set('pageName', 'Payment')
    .set('viewChange', 'Adyen: Payment completed callback')
    .set('eventInfo[0]', 'Payment', 'Adyen Completed');
  dl.write('interaction');
};

export const trackOnAdyenStatusCheckSuccess = () => {
  const dl = dataLayer.clone();
  dl.set('pageName', 'Payment')
    .set('viewChange', 'Adyen: Status check COMPLETED')
    .set('eventInfo[0]', 'Payment', 'Status COMPLETED');
  dl.write('interaction');
};

export const trackOnAdyenStatusCheckFailed = (state: string) => {
  const dl = dataLayer.clone();
  dl.set('pageName', 'Payment')
    .set('viewChange', `Adyen: Status check ${state}`)
    .set('eventInfo[0]', 'Payment', `Status ${state}`);
  dl.write('interaction');
};
